import { render, staticRenderFns } from "./result-add-to-cart-button.vue?vue&type=template&id=54cf848a&"
import script from "./result-add-to-cart-button.vue?vue&type=script&lang=ts&"
export * from "./result-add-to-cart-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports